import { ELogLevel, LoggerType } from '@services/errorService';

import {
  IPaypalOaltInitiate,
  IPaypalSourceResponse,
  IPaypalSource,
  EShippingPreference,
  EUserAction,
  EAttributeStatus,
  EPaypalStatus,
  IPaypalOaltInitiateApiResponse,
} from './model';
import { isPaypalOaltInitiateResponse } from './model.guard';

export const mappingFunction = (
  response: IPaypalOaltInitiateApiResponse,
  logger: LoggerType,
): IPaypalOaltInitiate | null => {
  if (!isPaypalOaltInitiateResponse(response)) {
    logger({
      logLevel: ELogLevel.WARNING,
      logMessage: 'Unable to decode Paypal Initiate for Oalt Response',
      additionalData: [{ key: 'Paypal Initiate OaLT Response', data: response }],
    });
    return null;
  }
  const { data } = response;

  return {
    ...data,
    status: data.status as EPaypalStatus,
    paymentSource: data.paymentSource ? mapPaypalSource(data.paymentSource) : null,
  };
};

const mapPaypalSource = (paypalSourceResponse: IPaypalSourceResponse): IPaypalSource => {
  if (!paypalSourceResponse.paypal) {
    return { ...paypalSourceResponse, paypal: null };
  }
  // experience context
  const experienceContextReponse = paypalSourceResponse.paypal.experienceContext;
  const experienceContext = experienceContextReponse && {
    ...experienceContextReponse,
    shippingPreference: paypalSourceResponse.paypal.experienceContext?.shippingPreference as EShippingPreference,
    userAction: paypalSourceResponse.paypal.experienceContext?.userAction as EUserAction,
  };

  // attributes response
  const attributesResponse = paypalSourceResponse.paypal.attributes;
  const attributes = attributesResponse && {
    vault: {
      ...attributesResponse.vault,
      status: paypalSourceResponse.paypal.attributes?.vault.status as EAttributeStatus,
    },
  };
  return {
    ...paypalSourceResponse,
    paypal: {
      experienceContext,
      attributes,
    },
  };
};
